import { createSlice } from "@reduxjs/toolkit";
import { fetchStats, fetchHeatmapData } from "../thunks/statsThunks";

const statsSlice = createSlice({
  name: "stats",
  initialState: {
    data: null,
    loading: false,
    silentLoading: false,
    error: null,
    heatmapCounts: null,
    heatmapLastParams: null,
    heatmapLoading: false,
  },
  reducers: {
    clearStatsError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStats.pending, (state, action) => {
        if (action.meta.arg?.silent) {
          state.silentLoading = true;
        } else {
          state.loading = true;
        }
        state.error = null;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.silentLoading = false;
      })
      .addCase(fetchStats.rejected, (state, action) => {
        state.loading = false;
        state.silentLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchHeatmapData.pending, (state) => {
        state.heatmapLoading = true;
      })
      .addCase(fetchHeatmapData.fulfilled, (state, action) => {
        state.heatmapCounts = action.payload;
        state.heatmapLastParams = action.meta.arg?.params || {};
        state.heatmapLoading = false;
      })
      .addCase(fetchHeatmapData.rejected, (state) => {
        state.heatmapLoading = false;
      });
  },
});

export const { clearStatsError } = statsSlice.actions;
export default statsSlice.reducer;
